import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'
import Select from 'src/Libs/inputs/formik/Select'
import { Company } from 'src/State/User/UserModel'

interface Props {
  company?: Company
}

const CompanyShowroomModalFields: React.FC<Props> = ({ company }) => {
  const { t } = useCustomTranslation()
  const { allCountries } = useCountryOptions()

  return (
    <Grid container justifyContent="flex-end" paddingTop={'20px'}>
      <Grid item xs={12} md={6}>
        <Grid container>
          <Grid item xs={12}>
            <TextField label={t('common.name')} name={'name'} required />
          </Grid>
          <Grid item xs={12}>
            <TextField label={t('common.address')} name={'address'} required />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label={t('common.zip')} name={'postalCode'} required />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label={t('common.location')} name={'city'} required />
          </Grid>
          <Grid item xs={12}>
            <Select label={t('common.country')} name={'countryCode'} options={allCountries} isSearchable required />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container>
          <Grid item xs={12}>
            <TextField label={t('common.phone')} name={'phone'} />
          </Grid>
          <Grid item xs={12}>
            <TextField label={t('common.fax')} name={'fax'} />
          </Grid>
          <Grid item xs={12}>
            <TextField label={t('common.email')} name={'email'} />
          </Grid>
          <Grid item xs={12}>
            <TextField label={t('common.website')} name={'website'} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CompanyShowroomModalFields
